export const TRIGGERBEE_LINK_HELP = {
  automations: {
    intro: 'https://help.triggerbee.com/en/articles/11069583-intro-to-automations',
  },
  'onsite-campaigns': 'https://help.triggerbee.com/en/articles/11205049-how-to-create-a-campaign',
  'contact-import': 'https://help.triggerbee.com/en/articles/11204973-profiles',
  'identity-visitor': 'https://help.triggerbee.com/en/articles/11196911-identifying-visitors',
  'variables-accounts': 'https://help.triggerbee.com/en/articles/11051619-brand-settings',
  'form-responses': 'https://help.triggerbee.com/en/articles/11196855-form-responses',
  zapier: 'https://help.triggerbee.com/en/articles/11059188-integrate-with-zapier',
  customCode: 'https://help.triggerbee.com/en/articles/11405853-component-library',
  scriptEvents: 'https://help.triggerbee.com/en/articles/11403014-custom-script-and-css',
};
